// extracted by mini-css-extract-plugin
export default {"color-box":"color-box--QbMpJAgDl0","colorBox":"color-box--QbMpJAgDl0"};